import React, { useEffect, useState } from 'react';
import styles from './RequestsBlock.module.scss';
import useHousingStockRequests from '../../../../../../queries/useHousingStockRequests';
import { Empty, Spin } from 'antd';
import {
  setRequestDrawerVisible,
  setSelectedRequestId,
} from '../../../../../../../../actions/requestCardActions';
import { useDispatch, useSelector } from 'react-redux';
import RelatedRequest from '../../../../../../components/ui/RelatedRequest';
import useCombinedFilter from '../../../../../../hooks/useCombinedFilter';
import useFilterRalated from '../../../../../../hooks/useFilterRalated';
import useCardPagination from '../../../../../../../../hooks/useCardPagination';
import RelatedObjectsFilter from '../../../../../../components/ui/RelatedObjectsFilter/RelatedObjectsFilter';
import useRequestsCount from '../../../../../../hooks/useRequestsCount';
import CountView from '../CountView/CountView';
import { declensions } from '../../../../../../constants/declensions';
import FlatFilterRequestAttributes from '../FlatFilterRequestAttributes/FlatFilterRequestAttributes';
import useAttributiesFilter from '../../../../../../hooks/useAttributiesFilter';
import { requestFlatPeriod } from '../../../../../../constants/requestFlat';

const cardSize = 8;

const selectReuests = (data = []) => {
  if (!data || !data?.length) return [];

  return data?.filter((item) => item?.statusId !== 4);
};

const RequestsBlock = ({ addressId }) => {
  const dispatch = useDispatch();

  const { monitoringStage, dateExcess } = useSelector(
    (state) => state.housingStockStore
  );

  const [valuesAttributes, setValuesAttributes] = useState([]);

  const { data: requests, isFetching: isRequestsFetching } =
    useHousingStockRequests(
      { addressId },
      { staleTime: Infinity, select: selectReuests }
    );

  const filteredRequestsForAttribute = useAttributiesFilter(
    requests,
    valuesAttributes,
    dateExcess
  );

  const { stageFilter, warFilter } = useCombinedFilter(
    filteredRequestsForAttribute
  );

  const {
    filteredDate,
    handleChangeStageFilter,
    handleChangeWarrantyFilter,
    selectedStage,
    selectedWar,
  } = useFilterRalated(filteredRequestsForAttribute, [String(monitoringStage)]);

  const values = useRequestsCount(filteredDate);

  const { shownItems, pagination } = useCardPagination(filteredDate, cardSize);

  const handleItemClick = (requestId) => {
    dispatch(setSelectedRequestId(requestId));
    dispatch(setRequestDrawerVisible(true));
  };

  const handleChangeAttributies = (_evt, newValue) => {
    if (valuesAttributes?.includes(newValue)) {
      const newValues = valuesAttributes?.filter((value) => value !== newValue);

      setValuesAttributes(newValues);

      return;
    }

    setValuesAttributes([...valuesAttributes, newValue]);
  };

  useEffect(() => {
    if (!!monitoringStage) {
      handleChangeStageFilter([String(monitoringStage)]);
    }
  }, [monitoringStage]);

  return (
    <div className={styles.root}>
      {isRequestsFetching ? (
        <Spin />
      ) : (
        <>
          {!!(requests && !!requests?.length) && (
            <div className={styles.header}>
              <div className={styles.box}>
                {!!values?.length && (
                  <div className={styles.viewRow}>
                    <CountView
                      values={values || []}
                      words={declensions.request}
                      isSquare
                    />
                  </div>
                )}
                <FlatFilterRequestAttributes
                  values={valuesAttributes}
                  onChange={handleChangeAttributies}
                />
              </div>
              <div className={styles.box}>
                <RelatedObjectsFilter
                  handleChangeStageFilter={handleChangeStageFilter}
                  stageFilter={stageFilter}
                  warFilter={warFilter}
                  selectedStageFilter={selectedStage}
                  selectedWarFilter={selectedWar}
                  handleChangeWarrantyFilter={handleChangeWarrantyFilter}
                />
                {requests?.length > cardSize ? pagination : undefined}
              </div>
            </div>
          )}
          <div className={styles.content}>
            {filteredDate?.length > 0 ? (
              shownItems.map((item) => (
                <RelatedRequest
                  key={item.id}
                  request={item}
                  onItemClick={handleItemClick}
                  dayExcess={dateExcess}
                  isExpiredIndicators={
                    !!(
                      !valuesAttributes?.length ||
                      valuesAttributes?.includes(requestFlatPeriod.expired)
                    )
                  }
                  isDedlineIndicators={
                    !!(
                      !valuesAttributes?.length ||
                      valuesAttributes?.includes(requestFlatPeriod.rightTime)
                    )
                  }
                  isExcessIndicators={
                    !!(
                      !valuesAttributes?.length ||
                      valuesAttributes?.includes(requestFlatPeriod.excess)
                    )
                  }
                />
              ))
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default RequestsBlock;
